import type { StaticEntityType } from "@config";
import { Element, Set } from "@library-containers/layers";
import { StyledStep } from "../styles/Narrator.styled";
import "../styles/narrator-pdf.scss";
import type { NarratorProps } from "../types";

export const NarratorPdf = ({ entity }: { entity: StaticEntityType }) => {
  const {
    settings,
    children: entityChildren,
    id,
  } = entity as StaticEntityType<NarratorProps>;
  const elements = getElements(entity);

  const narratorStyle = settings.style ?? "side-by-side";
  const narratorLayout =
    narratorStyle === "fullscreen-side-by-side" && settings.layout === "center"
      ? "left"
      : (settings.layout ?? "right");

  return (
    <div
      className="combo combo-narrator-pdf"
      data-sd-cid="cWE8L1L6FAVPP3jK"
      data-narrator-layout={narratorLayout}
      data-narrator-style={narratorStyle}
    >
      {entityChildren.map((set: StaticEntityType, i) => {
        const media = elements[set.id] as StaticEntityType;

        return (
          <StyledStep
            className="combo-narrator-pdf__step-container"
            key={i}
            $contentOpacity={1}
            $stepStyle={{
              bgColor: settings.stepBackgroundColor ?? "#ffffff",
              borderColor: settings.stepBorderColor,
              borderWidth: settings.stepBorderWidth,
              borderRadius: settings.stepBorderRadius,
            }}
          >
            <Set
              entity={{
                ...set,
                layers: {
                  ...(entity.layers || {}),
                  combo: { settings, index: i, id },
                },
              }}
            />

            <div className="combo-narrator-pdf__step-media">
              {media && <Element entity={media} />}
            </div>
          </StyledStep>
        );
      })}
    </div>
  );
};

const getElements = (entity: StaticEntityType) => {
  const elements: Record<string, unknown> = {};
  entity.children.forEach((set: StaticEntityType) => {
    if (set && set.children && set.children[1]) {
      const element = set.children[1].children[0];
      elements[set.id] = element;
    }
  });
  return elements;
};
